import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CATEGORIES } from '../../services/recipeService';

const RecipeCard = ({ recipe }) => {
  const navigate = useNavigate();
  const categoryLabels = (recipe.categories || [])
    .map((cat) => CATEGORIES.find((c) => c.value === cat)?.label || cat);
  const visibleLabels = categoryLabels.slice(0, 2);
  const extraCount = categoryLabels.length - visibleLabels.length;
  const totalTime = (recipe.prep_time || 0) + (recipe.cook_time || 0);

  return (
    <div style={styles.card} onClick={() => navigate(`/recipes/${recipe.id}`)}>
      <div style={styles.imageWrap}>
        {recipe.photo_url ? (
          <img src={recipe.photo_url} alt={recipe.title} style={styles.image} />
        ) : (
          <div style={styles.placeholder}>🍽️</div>
        )}
        {categoryLabels.length > 0 && (
          <div style={styles.categoryBadgeRow}>
            {visibleLabels.map((label) => (
              <span key={label} style={styles.categoryBadge}>{label}</span>
            ))}
            {extraCount > 0 && <span style={styles.categoryBadge}>+{extraCount}</span>}
          </div>
        )}
      </div>
      <div style={styles.body}>
        <h3 style={styles.title}>{recipe.title}</h3>
        <div style={styles.meta}>
          {totalTime > 0 && <span>⏱️ {totalTime} min</span>}
          {recipe.servings && <span>🍴 {recipe.servings} servings</span>}
        </div>
      </div>
    </div>
  );
};

const styles = {
  card: {
    backgroundColor: 'white',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    cursor: 'pointer',
    transition: 'transform 0.15s ease',
  },
  imageWrap: {
    position: 'relative',
    width: '100%',
    height: '160px',
    backgroundColor: '#fdf0e3',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  placeholder: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '48px',
  },
  categoryBadgeRow: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '4px',
  },
  categoryBadge: {
    backgroundColor: 'rgba(255,255,255,0.9)',
    color: '#e67e22',
    padding: '4px 10px',
    borderRadius: '20px',
    fontSize: '11px',
    fontWeight: '600',
  },
  body: {
    padding: '16px',
  },
  title: {
    margin: '0 0 8px 0',
    fontSize: '16px',
    color: '#333',
  },
  meta: {
    display: 'flex',
    gap: '12px',
    fontSize: '13px',
    color: '#888',
  },
};

export default RecipeCard;
